import { Switch } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import type { EnabledSwitchProps } from './types';

const EnabledSwitch = (props: EnabledSwitchProps) => {
  const { t } = useTranslation();
  const { renderText, checked, onChange, size = 'md', ...rest } = props;

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      size={size}
      text={
        renderText
          ? renderText(checked ?? false)
          : checked
            ? t('common:common.label.used')
            : t('common:common.label.unused')
      }
      {...rest}
    />
  );
};

export default EnabledSwitch;
